import {
  createTheme,
  Direction,
  StyledEngineProvider,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";

import { useMemo } from "react";
import { CssBaseline } from "@mui/material";
import IBaseLayoutProps from "@/interfaces/Props/IBaseLayoutProps";
import componentsOverride from "./overrides";

const ThemeCustomization = (props: IBaseLayoutProps) => {
  const { children } = props;

  const themeOptions = useMemo(
    () => ({
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1536,
        },
      },
      direction: "ltr" as Direction,
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    }),
    []
  );

  let themes = createTheme(themeOptions);
  themes.components = componentsOverride(themes);
  themes = responsiveFontSizes(themes);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeCustomization;
